import { createContext, useContext, useState, useEffect } from 'react';
import api from '../utils/api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('match-a_token');
    if (token) {
      api.get('/profile/me')
        .then(res => setUser(res.data))
        .catch(() => localStorage.removeItem('match-a_token'))
        .finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, []);

  const login = async (email, password) => {
    const res = await api.post('/auth/login', { email, password });
    localStorage.setItem('match-a_token', res.data.token);
    const me = await api.get('/profile/me');
    setUser(me.data);
    return me.data;
  };

  const signup = async (email, password, name) => {
    const res = await api.post('/auth/signup', { email, password, name });
    // Don't set token or user since email verification is required
    return res.data;
  };

  const logout = () => {
    localStorage.removeItem('match-a_token');
    setUser(null);
  };

  const refreshUser = async () => {
    const res = await api.get('/profile/me');
    setUser(res.data);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, signup, logout, refreshUser }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
